import React from "react";
import {
  useProfileChangePhotoMutation,
  useProfileUserDeleteMutation,
  useProfileViewQuery,
} from "../../redux/profileApi";
import { toast } from "react-toastify";
import config from "../../utils/config";
import Swal from "sweetalert2";

const { imageUrl } = config;

const maskedEmail = (email) => {
  if (!email) return "-";
  if (email.length <= 20) return email;
  return `${email.slice(0, 12)}...${email.slice(-5)}`;
};

function UserInfo() {
  const {
    data: userData,
    isLoading: profileLoading,
    refetch: refetchUser,
  } = useProfileViewQuery();
  const [profileChangePhoto, { isLoading: changingPhoto }] =
    useProfileChangePhotoMutation();
  const [profileUserDelete, { isLoading: deletingUser }] =
    useProfileUserDeleteMutation();

  const updateProfileImage = async (e) => {
    const file = e.target.files[0];

    console.log(file);
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!validTypes.includes(file.type)) {
      toast.dismiss();
      toast.error("Only JPG, PNG or WEBP images are allowed");
      e.target.value = "";
      return;
    }

    if (file.size < 10240 || file.size > 2097152) {
      toast.error("Image size must be between 10KB and 2MB");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("profile_photo", file);

    const res = await profileChangePhoto(formData);
    const { error, data } = res;

    if (error) {
      toast.dismiss();
      toast.error(error?.data?.message || "Failed to upload photo");
      refetchUser();
    } else if (data?.message) {
      toast.success(data.message);
      refetchUser();
    }
    e.target.value = "";
  };

  const deleteUser = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete your profile?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const res = await profileUserDelete({});
      const { error, data } = res;

      console.log(res.data, res.error);

      if (error) {
        toast.error(error?.data?.message || "Failed to delete user");
      } else if (data?.message) {
        toast.success(data.message);
        refetchUser();
      }
    }
  };

  return (
    <div className="auth-left col-lg-3 mb-3">
      <div className="white_box h_100 mb-0">
        <div className="user_profile">
          {userData?.data?.profile_photo ? (
            <img
              src={imageUrl + "/" + userData?.data?.profile_photo}
              alt="Profile"
              className="img-fluid cover-img"
              title="Change profile photo" // <-- native tooltip text
              aria-label="Change profile photo"
              style={{ cursor: "pointer" }} // <-- indicate interactivity
            />
          ) : (
            <img
              src="/assets/img/user_profile.png"
              alt="Default profile"
              className="img-fluid"
              title="Upload profile photo" // <-- native tooltip text
              aria-label="Upload profile photo"
              style={{ cursor: "pointer" }} // <-- indicate interactivity
            />
          )}

          <div className="edit-profile position-absolute">
            <input
              type="file"
              id="img1"
              style={{ display: "none" }}
              onChange={updateProfileImage}
            />
            <label
              htmlFor="img1"
              className="editlabel"
              title="Upload profile photo"
              aria-label="Upload profile photo"
            >
              {/* <i className="fa fa-edit"></i> */}
            </label>
          </div>
        </div>

        <h5 className="user text-center mt-3 mb-5">
          {userData?.data?.firstName}{" "}
          {userData?.data?.lastName === "null" ? "" : userData?.data?.lastName}
        </h5>

        <div className="profile-info info-main-outer ">
          <ul>
            <li className="user row mb-2">
              <span className="col-auto">Email:</span>
              <span
                className="col-auto ml-auto"
                title={userData?.data?.email || "-"} // tooltip shows full email
              >
                {maskedEmail(userData?.data?.email) || "-"}
              </span>
            </li>
            <li className="user row mb-2">
              <span className="col-auto">Mobile No.:</span>
              <span className="col-auto ml-auto">
                {userData?.data?.phone || "-"}
              </span>
            </li>
            <li className="user row mb-2">
              <span className="col-auto">KYC:</span>
              <span className="col-auto ml-auto">
                {userData?.data?.kyc_status === 1 ? "COMPLETED" : "PENDING"}
              </span>
            </li>

            {userData?.blockStatus !== 2 && (
              <div className="form-group col-lg-6 col-12">
                <button onClick={deleteUser} className="btn btn_man">
                  Delete User
                </button>
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default UserInfo;
